module.exports = __webpack_public_path__ + "static/img/answer_error_icon@2x.a5ac316.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/answer/answer_error_icon@2x.png
// module id = on6d
// module chunks = 0